import withRouter from 'Common/withRouter';
import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { LayoutHook } from 'slices/layouts/hook';
import { changeLayoutMode } from 'slices/thunk';

const NonAuthLayout = (props: any) => {
  const dispatch = useDispatch<any>();

  const { layoutModeType } = LayoutHook();
  useEffect(() => {
    if (layoutModeType) {
      dispatch(changeLayoutMode(layoutModeType));
    }
  }, [layoutModeType, dispatch]);

  useEffect(() => {
    document.documentElement.classList.add('light', 'scroll-smooth', 'group');
    return () => {
      document.documentElement.classList.remove('light', 'scroll-smooth', 'group');
    };
  }, []);

  return <React.Fragment>{props.children}</React.Fragment>;
};

export default withRouter(NonAuthLayout);
